import { route } from 'quasar/wrappers'
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'

import routes from './routes'
import { useCurrentBookingStore } from 'stores/current-booking'
import { RouteName } from 'src/models/route'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory

  const router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  })

  // Keep the current-booking store in sync with the URL: clear it whenever the
  // `locationId` route param is gone or points at a different location than the
  // one currently cached. The location page reloads it for the active location.
  router.afterEach((to) => {
    const currentBookingStore = useCurrentBookingStore()
    const rawLocationId = to.params.locationId
    const locationId = Array.isArray(rawLocationId)
      ? rawLocationId[0]
      : rawLocationId

    if (!locationId) {
      currentBookingStore.clear()
      return
    }

    if (currentBookingStore.currentLocationId !== Number(locationId)) {
      currentBookingStore.clear()
      return
    }

    // Same location, but the URL left the rental/reservation flow: drop the flow
    // selection (flow type, period type, duration) while keeping the location.
    const inFlow = to.matched.some(
      (record) =>
        record.name === RouteName.RENTAL ||
        record.name === RouteName.RESERVATION,
    )
    if (!inFlow) {
      currentBookingStore.clearFlow()
    }
  })

  return router
})
